import { Row, Col, Card, Statistic, PageHeader } from 'antd';
import { FC } from 'react';
import RequestsChart from '../components/charts/requests-chart';
import ErrorLogsTable from '../components/tables/error-logs-table';
import RequestLogsTable from '../components/tables/request-logs-table';
import MelipayamakCredit from '../components/widgets/melipayamak-credit';
import YassicialBalance from '../components/widgets/yassicial-balance';
import SharpsmmBalance from '../components/widgets/sharpsmm-balance';

const DashboardRoute: FC = () => {
    return <main>
           <PageHeader
        title="داشبورد"
        style={{ padding: " 16px 0" }}
        />
        <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
        <Col xs={12}>
                <YassicialBalance />
            </Col>
            <Col xs={12}>
                <SharpsmmBalance />
            </Col>
            <Col xs={12}>
                <MelipayamakCredit/>
            </Col>
            <Col xs={24}>
                <RequestsChart />
            </Col>
            <Col xs={24}>
                <ErrorLogsTable />
            </Col>
            <Col xs={24}>
                <RequestLogsTable />
            </Col>
      
        </Row>
    </main>;
}

export default DashboardRoute;
